(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
 document.addEventListener('DOMContentLoaded', function() {
  const slider = document.querySelector('.horizontal-product-list-carousel');

  let isDragging = false;
  let startX;
  let scrollLeft;
  let velX = 0;
  let momentumID;

  if (slider) {
    // Enable click + drag to scroll
    slider.addEventListener('mousedown', (e) => {
      isDragging = true;
      slider.classList.add('active');
      startX = e.pageX - slider.offsetLeft;
      scrollLeft = slider.scrollLeft;
      cancelMomentumTracking();
    });

    slider.addEventListener('mouseleave', () => {
      if (isDragging) startMomentumTracking();
      isDragging = false;
      slider.classList.remove('active');
    });

    slider.addEventListener('mouseup', () => {
      if (isDragging) startMomentumTracking();
      isDragging = false;
      slider.classList.remove('active');
    });

    slider.addEventListener('mousemove', (e) => {
      if (!isDragging) return;
      e.preventDefault();
      const x = e.pageX - slider.offsetLeft;
      const walk = (x - startX) * 1.5; // Scroll speed multiplier
      const prevScrollLeft = slider.scrollLeft;
      slider.scrollLeft = scrollLeft - walk;
      velX = slider.scrollLeft - prevScrollLeft;
    });

    // Enable wheel scroll vertical -> horizontal
    slider.addEventListener('wheel', (e) => {
      if (Math.abs(e.deltaY) > Math.abs(e.deltaX)) {
        e.preventDefault();
        slider.scrollLeft += e.deltaY;
      }
    }, { passive: false });

    // Prevent dragging images and links inside
    slider.querySelectorAll('img, a').forEach(el => {
      el.addEventListener('dragstart', (e) => {
        e.preventDefault();
      });
    });
  }

  // Momentum scrolling after drag
  function startMomentumTracking() {
    cancelMomentumTracking();
    momentumID = requestAnimationFrame(momentumLoop);
  }

  function cancelMomentumTracking() {
    cancelAnimationFrame(momentumID);
  }

  function momentumLoop() {
    slider.scrollLeft += velX;
    velX *= 0.95; // friction
    if (Math.abs(velX) > 0.5) {
      momentumID = requestAnimationFrame(momentumLoop);
    }
  }
});

  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
        document.addEventListener('DOMContentLoaded', function () {
      var figures = document.querySelectorAll('.product-card__figure');

      figures.forEach(function (figure) {
          figure.addEventListener('touchstart', function () {
              // Add the class to simulate hover
              this.classList.add('touch-active');
              var productImage = this.querySelector('.product-card__image--primary');
              if (productImage) {
                  productImage.classList.add('horizontal-shaking');
              }
          });

          figure.addEventListener('touchend', function () {
              // Remove the class when the touch ends
              this.classList.remove('touch-active');
              var productImage = this.querySelector('.product-card__image--primary');
              if (productImage) {
                  productImage.classList.remove('horizontal-shaking');
              }
          });

          // Optional: Handle touchcancel to remove the class if touch is interrupted
          figure.addEventListener('touchcancel', function () {
              this.classList.remove('touch-active');
              var productImage = this.querySelector('.product-card__image--primary');
              if (productImage) {
                  productImage.classList.remove('horizontal-shaking');
              }
          });
      });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ingredientsmodal"] && !Shopify.designMode) return;
  try {
    
  // Get the modal
  var ingredientmodal = document.getElementById("ingredientmodal");

  // Get the button that opens the modal
  var ingredientmodalbtn = document.querySelector(".shopify-section--specification-table > div > div > div.section-stack__intro > div > a");

  // Get the <span> element that closes the modal
  var span = document.getElementsByClassName("ingredientmodalclose")[0];

  // When the user clicks the button, open the modal
  ingredientmodalbtn.onclick = function(event) {
      event.preventDefault();
      ingredientmodal.style.display = "block";
  }

  // When the user clicks on <span> (x), close the modal
  span.onclick = function() {
      ingredientmodal.style.display = "none";
  }

  // When the user clicks anywhere outside of the modal, close it
  window.onclick = function(event) {
      if (event.target == ingredientmodal) {
          ingredientmodal.style.display = "none";
      }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["passwordintro"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
    // Set the dynamic vh value once on load
    function setInitialVH() {
        let vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty('--dvh', `${vh * 100}px`);
    }

    setInitialVH();

    const container = document.querySelector('#shopify-section-template--23205915296047__passwordintro_trM8dT .bgsection');
    const img = new Image();
    img.src = '//blackwolfnutrition.com.au/cdn/shop/t/4/assets/BWolf-heroimg.jpg?v=104194023539162353401723088810';
    img.onload = function() {
        const aspectRatio = img.width / img.height;
        const containerWidth = container.offsetWidth;
        const containerHeight = container.offsetHeight;
        const containerAspectRatio = containerWidth / containerHeight;

        let bgWidth, bgHeight;
        if (containerAspectRatio > aspectRatio) {
            bgWidth = containerWidth;
            bgHeight = containerWidth / aspectRatio;
        } else {
            bgHeight = containerHeight;
            bgWidth = containerHeight * aspectRatio;
        }

        container.style.setProperty('--bg-width', `${bgWidth}px`);
        container.style.setProperty('--bg-height', `${bgHeight}px`);
        container.style.setProperty('--initial-x', '50%');
        container.style.setProperty('--initial-y', '50%');
    };

    let targetX = '50%';
    let targetY = '50%';
    let currentX = '50%';
    let currentY = '50%';

    function updateSpotlightPosition() {
        currentX = currentX !== targetX ? parseFloat(currentX) + (parseFloat(targetX) - parseFloat(currentX)) * 0.1 + '%' : currentX;
        currentY = currentY !== targetY ? parseFloat(currentY) + (parseFloat(targetY) - parseFloat(currentY)) * 0.1 + '%' : currentY;
        container.style.setProperty('--x', currentX);
        container.style.setProperty('--y', currentY);
        requestAnimationFrame(updateSpotlightPosition);
    }

    document.addEventListener('mousemove', function(e) {
        const rect = container.getBoundingClientRect();
        targetX = `${((e.clientX - rect.left) / rect.width) * 100}%`;
        targetY = `${((e.clientY - rect.top) / rect.height) * 100}%`;
    });

    function getRandomInt(min, max) {
        return Math.floor(Math.random() * (max - min + 1)) + min;
    }

    function moveSpotlightRandomly() {
        const width = container.offsetWidth;
        const height = container.offsetHeight;
        targetX = `${(getRandomInt(0, width) / width) * 100}%`;
        targetY = `${(getRandomInt(0, height) / height) * 100}%`;
    }

    function detectTouchDevice() {
        return 'ontouchstart' in window || navigator.maxTouchPoints;
    }

    if (detectTouchDevice()) {
        setInterval(moveSpotlightRandomly, 1000); // Move the spotlight every 2 seconds
    }

    requestAnimationFrame(updateSpotlightPosition);
});

  } catch(e) { console.error(e); }
})();
})();
